<template>
  <div class="inviteUpdatePop">
    <div class="pop">
      <img @click="close()" src="../../assets/images/invite/close.png" alt="" class="close">
      <img src="../../assets/images/invite/updatePopBg.webp" alt="" class="bg">
      <div class="updateTitle">{{ $t('lang.inviteUpdatePop.updateTitle') }}</div>
      <div class="description">{{ $t('lang.inviteUpdatePop.description') }}</div>
      <div class="updatelist">
        <li>{{ $t('lang.inviteUpdatePop.updatelist1') }}</li>
        <li>{{ $t('lang.inviteUpdatePop.updatelist2') }}</li>
      </div>
      <div class="warning">
        <img src="../../assets/images/invite/warningIcon.png" alt="" class="warningIcon">
        {{ $t('lang.inviteUpdatePop.warning') }}
      </div>
      <div @click="close()" class="okBtn" :style="{backgroundImage:'url('+require('../../assets/images/invite/ok.webp')+')'}">{{ $t('lang.inviteUpdatePop.ok') }}</div>
      <div class="warning2">
        {{ $t('lang.inviteUpdatePop.warning2') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  methods: {
    close () {
      this.$emit('handleClose')
    }
  }
}
</script>

<style lang="less" scoped>
.inviteUpdatePop{
  height: 100vh;
  width: 100vw;
  background-color: rgba(0,0,0,.5);
  position: fixed;
  top: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  .pop{
    width: 86.666vw;
    height: 100vw;
    position: relative;
    animation: openBox 0.2s ease-in-out;
    .bg{
      height: 122vw;
      width: 107vw;
      position: absolute;
      top: -22.5vw;
      z-index: -1;
    }
    .close{
      position: absolute;
      height: 4.533vw;
      width: 4.333vw;
      right: 2vw;
      top: -8vw;
    }
    .updateTitle{
      font-family: 'Inter';
      color: #fff;
      font-style: italic;
      font-weight: 700;
      font-size: 6.111vw;
      text-align: center;
      text-transform: capitalize;
      background-clip: text;
      text-shadow: 0px 3px 1.5px rgba(0, 0, 0, 0.25);
      position: absolute;
      bottom: 85vw;
      left: 6vw;
    }
    .description{
      color: #9B9B9B;
      font-size: 3.333vw;
      width: 50.833vw;
      position: absolute;
      bottom: 70vw;
      left: 6vw;
    }
    .updatelist{
      color: #fff;
      font-size: 3.333vw;
      height: 8.888vw;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      position: absolute;
      bottom: 45vw;
      left: 6vw;
    }
    .warning{
      display: flex;
      align-items: center;
      font-size: 2.617vw;
      color: #FFE100;
      position: absolute;
      bottom: 28vw;
      //left: 6vw;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .warningIcon{
        width: 3.2vw;
        height: 3vw;
       margin-right: 1vw;
      }
    }
    .okBtn{
      display: flex;
      align-items: center;
      justify-content: center;
      background-size: 100% 100%;
      width: 73.333vw;
      height: 9.166vw;
      color: #000;
      font-weight: 700;
      position: absolute;
      bottom: 17vw;
      left: 6vw;
    }
    .warning2{
      font-size: 2.777vw;
      width: 76.413vw;
      height: 6.666vw;
      //background: linear-gradient(to right,
      //#999999 0%,
      //#999999 50%,
      //#CCCCCC 100%);
      background-color: rgb(65,61,66);
      border-radius: 50vw;
      display: flex;
      align-items: center;
      justify-content: center;
      color: rgba(255, 255, 255, 0.5);
      position: absolute;
      bottom: 6vw;
      left: 4.5vw;
    }
  }
  @keyframes openBox {
    0% {
      transform: scale(0);
      opacity: 0; /* 开始时完全透明 */
    }
    50% {
      transform: scale(1.1); /* 在中间稍微放大一点，增加视觉冲击 */
      opacity: 1; /* 在中间变为完全不透明 */
    }
    100% {
      transform: scale(1); /* 结束时恢复到正常大小 */
      opacity: 1; /* 保持完全不透明 */
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/inviteUpdatePop/index.vue